import { type QueryHookOptions, useQuery } from "@apollo/client";
import { ReportsListQuery } from "../graphql/queries";
import type {
  ReportsListQueryType,
  ReportsListQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useReportsQuery = (
  options?: QueryHookOptions<
    ReportsListQueryType,
    ReportsListQueryVariablesType
  >
) => {
  return useQuery<ReportsListQueryType, ReportsListQueryVariablesType>(
    ReportsListQuery,
    options
  );
};
